import { IconButton,styled } from "@mui/material"


const CustomIconButton = styled(IconButton)(({theme}) => ({
    color:theme.typography.colorGrey,
    borderRadius:'999px',
    border:'1px solid #e8e8e8',
    flexShrink:0

    }))

const CommonIconButton = ({children,sx,onClick})=>{
    return (
        <CustomIconButton sx={sx} onClick={onClick}>{children}</CustomIconButton>
    )
}
export default CommonIconButton